module.exports = __webpack_public_path__ + "console/img/cj.872e039d.svg";